const riot = require('riot');
import route from 'riot-route';
import ObjectId from 'bson-objectid';
riot.tag2('campaigns', '<div class="level"> <div class="level-left"> <div class="level-item" style="display:block"> <h1 class="title is-5">Campaigns overview</h1> </div> </div> <div class="level-right"> <form onsubmit="{setSearchFilter(null,0)}" class="level-item"> <div class="field is-grouped is-flexwrap"> <div class="control"> <span ref="filter_active" class="button is-small {is-success:filter.active===true,is-danger:filter.active===false}" onclick="{setToggleFilter(\'active\')}">Active</span> </div> <div class="control"> <span ref="filter_isAutomated" class="button is-small {is-success:filter.isAutomated===true,is-danger:filter.isAutomated===false}" onclick="{setToggleFilter(\'isAutomated\')}">DSP</span> </div> <div class="control" style="flex-shrink:1"> <div class="select is-small"> <select name="customer" ref="customer" onchange="{setCustomerFilter()}"> <option value="">Select customer</option> <option each="{customers}" selected="{filter.customer_id==_id}" riot-value="{_id}">{name}</option> </select> </div> </div> <div class="control has-icons-right" style="flex-shrink:1"> <input class="input is-info {is-warning:search_active} is-small" ref="new_name" oninput="{setSearchFilter(null,500)}" type="text" placeholder="Enter/Search campaign name" riot-value="{filter.$or ? filter.$or[0].name.$regex : \'\'}"> <span class="icon is-small is-right" onclick="{clearSearch}" style="cursor:pointer;pointer-events:all"> <i class="fas {fa-times:!search_active,fa-spin:search_active,fa-spinner:search_active}"></i> </span> </div> <div class="control"> <span class="button is-info is-small" onclick="{createCampaign}">Add <span class="is-hidden-mobile">Campaign</span></span> </div> </div> </form> </div> </div> <nav class="buttons has-addons" style="justify-content:center"> <button class="button is-small" each="{letter in abc}" onclick="{setSearchFilter(\'^\'+letter,0)}">{letter}</button> </nav> <div class="container"> <div each="{campaigns}" class="card is-collapse"> <header class="card-header {has-background-grey-light:!active}"> <a class="card-header-title" href="/#targeting/{_id}"> {name} </a> <a href="/#targeting/{_id}" if="{block_events}" class="card-header-icon"><span class="tag strike">IMP</span></a> <a href="/#targeting/{_id}" if="{isAutomated}" class="card-header-icon"><span class="tag">DSP</span></a> </a> </header> </div> </div> <div class="level mt-3"> <div class="level-left"> <div class="level-item"> <button if="{!end_of_line}" class="button is-small is-info" onclick="{loadMore}">Load more</button> </div> </div> </div>', '', '', function(opts) {

  var self = this,
      cid = opts.id,
      fs = require('fs')

  self.search_active = false
  self.abc = 'abcčdefghijklmnoprqsštvuvxyzž'

  var filters = api.get('filters')
  filters['campaigns'] = filters['campaigns'] || {$sort:{name:1},$limit:30,active:true,isAutomated:false}
  self.filter = filters['campaigns']
  self.campaigns = []
  self.customers = []

  this.setToggleFilter = function(fld) {
    return function(e) {
      e.preventDefault()
      var val = self.filter[fld]
      if (val===true) val=false
      else if (val===false) val='delete'
      else val=true
      if (val=='delete') delete self.filter[fld]
      else self.filter[fld] = val
      e.preventUpdate = true
      loadCampaigns()
    }
  }.bind(this)

  this.setCustomerFilter = function(val) {
    return function(e) {
      e.preventDefault()
      val = val || self.refs.customer.value
      if (!!val) self.filter.customer_id = val
      else delete self.filter.customer_id;
      e.preventUpdate = true
      loadCampaigns()
    }
  }.bind(this)

  var search_string = '', search_tmout = false
  function setSearch(str,delay) {

    if (str) {
      self.filter.$or = [
        {name : {
          $regex: str,
          $options: 'i'
        }},
        {campaign_id : {
          $regex: str,
          $options: 'i'
        }}
      ]
    } else delete self.filter.$or
    if (search_tmout) clearTimeout(search_tmout)
    search_tmout = setTimeout(loadCampaigns,delay)
  }
  this.setSearchFilter = function(val,delay) {
    return function(e) {
      e.preventDefault()
      val = val || self.refs.new_name.value
      self.refs.new_name.value = val
      setSearch(val,delay)

    }
  }.bind(this)
  this.clearSearch = function(e) {
    e.preventDefault()
    self.refs.new_name.value = ''
    setSearch('')

  }.bind(this)

	this.createCampaign = function(e) {
		e.preventDefault();
		e.stopPropagation();

		let name = self.refs.new_name.value;
		let customer_id = self.refs.customer.value;

		if (!customer_id)
			return api.emit('toast', { type:'danger', title:'Select a customer first' });
		if (!name)
			return api.emit('toast', { type:'danger', title:'Name cannot be emtpy' });

		let customer = self.customers.find(c => c._id == customer_id);

    var campaign_id = ObjectId()

		api.service('campaigns')
			.create({
        _id: {_oid:campaign_id},
        campaign_id: campaign_id,
				name: name,
				owner: customer.owner,
				customer_id: customer._id.toString(),
				dtstart:new Date(),
				isAutomated: false
			})
			.then(campaign => {
				route('targeting/' + campaign._id);

			})
			.catch(e => {
				api.emit('toast', { type:'danger', title:'Error creating campaign',content:e.message });
			});
	}.bind(this)

  self.on('mount',() => {
    loadCampaigns()
  })

  let last_id = false
  function loadCampaigns(append=false) {
    self.search_active = true;
	  self.update()

	  var filter = Object.assign({},self.filter)
	  if (append && last_id) filter.name = Object.assign({},filter.name,{$gt: last_id})

	  core.customerAPI.GetOrSet()
	  .catch(err => api.emit('toast', { type:'danger', title:'Error fetching customer list', content:err.message }))
	  .then(customers => {
		  self.customers = customers;
      return api.service('campaigns').find({query:filter})
    })
    .then(r => {
      self.search_active = false;
      if (append && r.data.length>0) {
        self.campaigns = self.campaigns.concat(r.data)
      } else {
        self.campaigns = r.data
      }
      last_id = r.data.length && r.data[r.data.length-1].name || false
      self.end_of_line = r.data.length < filter.$limit
      self.update()
    })
    .catch(e => {
      api.emit('toast',{type:'danger',title:'Error fetching campaigns',content:e.message})
      console.log('error campaigns',e)
    })
  }

  api.on('update-customer', (e) => {
   self.customers = api.get('customers')
   self.update()
  })

  this.loadMore = function(e) {
    e.preventDefault()
    e.preventUpdate = true
    loadCampaigns(true)
  }.bind(this)

});
